<template>
  <div class="unit-listing">
    <transition name="animate-filter">
      <div v-if="!expanded" @click.stop="isManuallyExpanded = true" class="collapsed">
        <div class="text">
          <button
            class="btn white border small"
            style="margin-right:10px;"
            @click.stop="openModal(['SkiSchoolLocationMap'])"
            v-if="SITE_CONFIG.skischool.map"
            >
              <span class="min-tablet">{{ $t('skischool.map-gathering-sites') }}</span> 
              <span class="max-mobile">{{ $t('skischool.map') }}</span> 
            <icon name="info-blue-white-bg" :scale="1.4" style="margin-top:-3px;" /></button>
          <button
            class="btn white border small"
            >{{ $t('general.cta.book') }} / {{ $t('general.pick-time') }}</button>
        </div>
        <div class="button">
          <icon name="chevron-down-white" />
        </div>
      </div>
    </transition>
    <transition name="animate-filter">
      <div v-if="expanded" class="expanded">
        <div @click.stop="isManuallyExpanded = false" class="header">
          <div class="text">{{ $t('general.close') }}</div>
          <div class="button">
            <icon name="chevron-up" />
          </div>
        </div>
        <div class="body">
          <table>
            <thead>
              <tr>
                <th scope="col" class="min-tablet" @click="openModal(['SkiSchoolLocationMap'])" style="cursor:pointer;" v-if="SITE_CONFIG.skischool.show_site">
                  {{ $t('skischool.gathering-site') }} <icon name="info-blue-white-bg" :scale="1.3" />
                </th>
                <th scope="col" class="min-tablet">
                  <span v-if="(['branas', 'kungsberget'].indexOf(SITE_CONFIG.site) !== -1) || !info.is_private">{{ $t('general.days') }}</span>
                  <span v-else>{{ $t('general.people-count') }}</span>
                </th>
                <th scope="col" class="min-tablet">
                  {{ $t('general.time') }}
                </th>
                <th scope="col" class="min-tablet" style="text-align:right;">
                  {{ $t('general.price') }}
                </th>
                <th scope="col" class="min-tablet"></th>
              </tr>
            </thead>
            <transition-group name="animate-pool-list" class="animate-pool-list" tag="tbody">
              <tr v-for="(course, index) in courses" :class="{ odd: index % 2 }" class="animate-pool-list-item" :key="course.id" @click.stop="openInfo(course)">
                <td scope="row" class="site" v-if="SITE_CONFIG.skischool.show_site">
                  <span v-if="course.site === 2"><icon name="berget" :scale="1.4" />{{ course.site_name }}</span>
                  <span v-else-if="course.site === 1"><icon name="byn" :scale="1.4" />{{ course.site_name }}</span>
                  <span v-else><icon name="gondol" :scale="1.4" />{{ course.site_name }}</span>
                </td>
                <td scope="row" class="unit-title">
                  <span v-if="(['branas', 'kungsberget'].indexOf(SITE_CONFIG.site) !== -1) || !info.is_private">
                    <span v-if="course.force_display_name">
                      <strong>{{ course.display_name }}</strong>
                    </span>
                    <span v-if="!course.force_display_name">
                      <span v-if="course.availableDays.length === 1 && showWhichDays">
                        <strong v-if="course.availableDays[0] === course.availableEndDays[0]">{{ course.availableDays | weekday | join | capitalize }}, </strong>
                        <strong v-else>{{ course.availableDays | weekday | join | capitalize }}-{{ course.availableEndDays | weekday | join | capitalize }}, </strong>
                      </span>
                      <strong v-if="course.days > 1">{{ course.days }} {{ $t('general.days') }}<span v-if="course.during_christmas">, {{ $t('general.christmas') }}</span></strong>
                      <strong v-if="course.days === 1">{{ course.days }} {{ $t('general.day') }}<span v-if="course.during_christmas">, {{ $t('general.christmas') }}</span></strong>
                    </span>
                  </span>
                  <span v-else><strong>{{ course.min_participants }}</strong> {{ $t('general.pieces-short') }}</span>
                </td>
                <td scope="row" class="">
                  <icon name="clock" :scale="1.1" /> {{course.minutes}}{{ $t('general.minutes-short') }}/{{ $t('skischool.lesson') }}
                </td>
                <td scope="row" class="unit-title">
                  <b>{{course.priceMax | currency}}</b>
                </td>

                <td class="actions">
                  <div>
                    <span v-if="$store.state.isDebugging">
                      {{ course.id }}/{{ course.pool_lid }}
                    </span>
                    <button
                      class="outline-button price-info-bt"
                      @click.stop="openInfo(course)"
                      >{{ $t('general.cta.book') }}</button>
                  </div>
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import moment from 'moment';

export default {
  props: ['courses', 'info'],
  components: {
  },
  data() {
    return {
      isManuallyExpanded: false,
    };
  },
  mounted() {
  },
  computed: {
    expanded() {
      return this.isManuallyExpanded;
    },
    showWhichDays() {
      // return this.SITE_CONFIG.site === 'branas';
      return false;
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    moment(d) {
      return moment(d);
    },
    openInfo(course) {
      window.CURRENT_ACTIVITY_ID = course.id;
      this.openModal(['SkiSchoolBooking', {
        pool: course.pool_lid,
        presenterGroup: course.presenter_group,
      }]);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

th
  text-transform: capitalize;

.unit-listing
  +max-mobile()
    padding-left 0px
    padding-right 0px

.outline-button
  button-reset()
  display: inline-block
  background white
  border 1px solid light-blue
  color deep-blue
  border-radius 4px
  text-transform uppercase
  padding 0.4rem 0.4rem 0.2rem 0.4rem
  line-height 1em
  font-weight bold
  font-size 11px
  transition-ease()
  &.price-info-bt
    min-width: auto
    padding: 0.4rem 0.4rem 0.3rem 0.4rem;
    +max-mobile()
      max-width: 160px
      min-width: 40%
      float: right;

  &:hover
    border-color alpha(deep-blue, .5)
    border-bottom-width: 1px
    background-color: light-blue-grey
    color #005580
  &:focus
    outline none
    border-color deep-blue
  &.active
    background-color deep-sea-blue
    border solid 1px light-blue-grey
    color white
  &.has-text
    .icon
      position: relative;
      top: -2px
      margin-right: 5px

.site .icon
  margin-right: 6px

.component
  transition-slide('animate-filter')
  padding: 5px 6px

.collapsed
  background-color pale-sky
  border-radius 0 0 3px 3px
  height 45px
  display flex
  align-items center
  cursor pointer

  .text
    color deep-blue
    font-weight bold
    flex auto
    text-align right
    padding-right space-2
    padding-left space-2
  .btn
    margin-top 15px
  .button
    background deep-blue
    color white
    width 45px
    align-self stretch
    border-radius 0px
    position relative
    border: 0px
    .icon
      position absolute
      left -7px
      top -6px
      margin-left 50%
      margin-top 50%




.expanded
  .header
    background-color deep-blue
    color white
    height 45px
    display flex
    align-items center
    cursor pointer
    position relative
    z-index 1
  .text
    font-weight bold
    flex auto
    text-align right
    padding-right space-2
    padding-left space-2
    text-transform uppercase
    letter-spacing letter-spacing-uppercase
  .button
    background pale-sky
    color deep-blue
    width 45px
    align-self stretch
    border-radius 0px
    position: relative;
    border 0px
    .icon
      position absolute
      left -7px
      top -6px
      margin-left 50%
      margin-top 50%
  .body

    shadow()
    table
      border-collapse collapse
      width 100%
      thead
        background-color alpha(deep-blue, .85)
        color white
      tbody
        background-color white
        border-top 0
        th
          i
            font-style normal
            font-weight normal
            display block
            color greyish-brown
            margin-top 2px
            font-size 95%
        &.animate-pool-list
          transition-list('animate-pool-list')

      tbody
        tr
          cursor pointer
          &.odd
            background-color pale-sky
          &:hover
            background-color #deebf0

      th, td
        padding 10px space-3
        +max-tablet()
          padding 10px space-1
        white-space nowrap
        line-height 1.25em
        text-align: left
        &.site
          +max-mobile()
            padding-top 12px
        &.actions
          +max-mobile()
            padding-bottom 12px
        &.wrap
          white-space normal
        &.no-padding
          padding-left 0
          padding-right 0
      +max-mobile()
        th,
        td
          width 100%
          display block
          padding 5px 15px 5px
          &.min-tablet
            display none
      th.sortable
        cursor pointer
      .actions
        text-align right
        b
          font-size: 13px;
          font-weight: bold;
          letter-spacing: 0.2px;
          color: #262626;
          line-height 28px
          display inline-block
        & > div
          display flex
          margin -5px
          & > *
            margin 5px

.favorite-icon-wrapper
  background-color white
  border 1px solid #bfd9e1
  border-radius 4px
  font-size 25px
  display: inline-block
  padding 0
  background-repeat: no-repeat;
  background-position: center
  background-image url(https://static.booking.branasgruppen.se/static/svg/heart.svg)
  background-size 70%
  height 28px
  width 28px
  cursor pointer
  &:hover
    opacity 0.8
  &.active
    background-image url(https://static.booking.branasgruppen.se/static/svg/heart-red.svg)
    //background-size cover
.unit-title
  b
    float right

.facts
  +max-mobile()
    display flex !important
    flex-wrap wrap
    & > div
      width 50%
.the-price
  +max-mobile()
    display none !important
</style>



// WEBPACK FOOTER //
// SkiSchoolListUnitsList.vue?bfa936ca